import { THEME_COLORS } from "./ThemeColorDefinition";

export const FONT_FAMILY = {
  primary: "'Rubik', sans-serif",
  rubik: "'Rubik', sans-serif",
  sans: "'Rubik', sans-serif",
} as const;

export const FONT_SIZE = {
  xs: "10px",
  sm: "12px",
  smMedium: "13px",
  
  base: "14px",
  md: "14px",
  mdLarge: "15px",
  
  lg: "16px",
  
  xl: "18px",
  "2xl": "20px",
  "3xl": "22px",
  "4xl": "24px",
  
  h3: "1.4rem",
  h2: "2.5rem",
  h1: "40px",
  display: "3rem",
} as const;

export const FONT_WEIGHT = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
} as const;

export const LINE_HEIGHT = {
  tight: 1.1,
  normal: 1.2,
  relaxed: 1.3,
  loose: 1.4,
  veryLoose: 1.5,
} as const;

export const TYPOGRAPHY_STYLES = {

  rubik: {
    fontFamily: FONT_FAMILY.primary,
    color: THEME_COLORS.text.primary,
  },
  

  rubikSmall: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    color: THEME_COLORS.text.primary,
  },
  
  rubikMedium: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.base,
    color: THEME_COLORS.text.primary,
  },
  
  rubikLarge: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.lg,
    color: THEME_COLORS.text.primary,
  },
  
  rubikXL: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.xl,
    color: THEME_COLORS.text.primary,
  },
  
  rubik2XL: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE["2xl"],
    color: THEME_COLORS.text.primary,
  },
  
  rubik3XL: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE["3xl"],
    color: THEME_COLORS.text.primary,
  },
  

  heading1: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.h1,
    fontWeight: FONT_WEIGHT.bold,
    lineHeight: LINE_HEIGHT.tight,
    color: THEME_COLORS.text.primary,
  },
  
  heading2: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.h2,
    fontWeight: FONT_WEIGHT.bold,
    lineHeight: LINE_HEIGHT.tight,
    color: THEME_COLORS.text.primary,
  },
  
  heading3: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.h3,
    fontWeight: FONT_WEIGHT.bold,
    lineHeight: LINE_HEIGHT.tight,
    color: THEME_COLORS.text.primary,
  },
  
  // Body text
  body: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.base,
    lineHeight: LINE_HEIGHT.normal,
    color: THEME_COLORS.text.primary,
  },
  
  bodySmall: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    lineHeight: LINE_HEIGHT.normal,
    color: THEME_COLORS.text.primary,
  },
  
  bodyLarge: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.lg,
    lineHeight: LINE_HEIGHT.normal,
    color: THEME_COLORS.text.primary,
  },
  

  caption: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.xs,
    lineHeight: LINE_HEIGHT.tight,
    color: THEME_COLORS.text.primary,
  },
  

  label: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    fontWeight: FONT_WEIGHT.bold,
    textTransform: "uppercase" as const,
    lineHeight: LINE_HEIGHT.normal,
    color: THEME_COLORS.text.primary,
  },
  
  labelMedium: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.base,
    fontWeight: FONT_WEIGHT.bold,
    textTransform: "uppercase" as const,
    color: THEME_COLORS.text.primary,
  },
  
  helperText: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.xs,
    fontStyle: "italic" as const,
    color: "rgba(0, 0, 0, 0.6)",
  },
  
  button: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.base,
    fontWeight: FONT_WEIGHT.bold,
    textTransform: "uppercase" as const,
    lineHeight: LINE_HEIGHT.tight,
  },
  
  buttonSmall: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    fontWeight: FONT_WEIGHT.bold,
    textTransform: "uppercase" as const,
  },
  
  display: {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.display,
    fontWeight: FONT_WEIGHT.bold,
    lineHeight: LINE_HEIGHT.tight,
  },
} as const;

export type TypographyStyle = typeof TYPOGRAPHY_STYLES;














